import React, { useState, useEffect } from 'react';
import isEqual from 'lodash/isEqual';
import { withRouter } from 'react-router';
import useNavigation, {
  PAGE_ACTIONS,
} from 'chameleon/ui-stack/hooks/useNavigation';
import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import LabelWithCheckbox from 'legacy-src/components/TeacherOrganize/components/LabelWithCheckbox';
import useLabelModal from 'legacy-src/components/TeacherOrganize/hooks/useLabelModal';
import Button from 'chameleon/ui-stack/ui/base/button';
import { LEFT_POPOVER_MENU_NAME } from '../utils/constants';
import './LabelListMenu.scss';

const LabelListMenu = ({
  router,
  assignedLabels = [],
  showCreateNewLabelAction = true,
  showBulkAction = true,
  onClose = () => {},
  isAdminOrCoordinator,
}) => {
  const { params, navigateWithParams } = useNavigation({
    router,
  });
  const { subject: masterSubject } = params || {};
  const { labels, parents, children, actions } = useTeacherOrganizeContext({
    masterSubject,
  });

  const {
    LabelModal,
    createEditModalProps,
    isCreateEditModalVisible,
    createNewLabel,
  } = useLabelModal({ masterSubject, router });

  const assignedLabelsInt = assignedLabels.map((t) => parseInt(t, 10));

  const [selectedLabels, setSelectedLabels] = useState(() =>
    Object.keys(labels).reduce((result, labelId) => {
      result[labelId] = assignedLabelsInt.includes(parseInt(labelId, 10));
      return result;
    }, {}),
  );

  const onLabelClick = (labelId) => (isSelected) => {
    setSelectedLabels((state) => ({
      ...state,
      [labelId]: isSelected,
    }));
  };

  useEffect(
    () => () => {
      setSelectedLabels(async (state) => {
        if (!isEqual(state, selectedLabels)) {
          onClose(state);
        }
        return state;
      });
    },
    [],
  );

  const renderChildren = (parentLabelId, childrenForParent) => {
    const hasChildren = Boolean(childrenForParent[parentLabelId]?.length > 0);

    return hasChildren ? (
      <ul className="p-0 m-0 pl-6">
        {childrenForParent[parseInt(parentLabelId)].map((childIndex) => (
          <li className="list-none p-0 m-0" key={childIndex}>
            <LabelWithCheckbox
              isSelected={assignedLabelsInt.includes(
                parseInt(labels[childIndex].labelId, 10),
              )}
              name={labels[childIndex].name}
              onSelect={onLabelClick(labels[childIndex].labelId)}
            />
          </li>
        ))}
      </ul>
    ) : null;
  };

  const teacherOrganizeNewLabelClickHandler = () => {
    if (isAdminOrCoordinator) {
      navigateWithParams({
        assignmentExampleModal: LEFT_POPOVER_MENU_NAME.create,
      });
    } else {
      createNewLabel();
      navigateWithParams({
        action: PAGE_ACTIONS.CREATE_LABEL,
      });
    }
  };

  return (
    <div className="p-5">
      {parents.map((parentLabelId) => (
        <ul
          className="border-b p-0 m-0 py-1 border-gray-300 last:border-none"
          key={parentLabelId}
        >
          <li className="p-0 m-0 list-none">
            <LabelWithCheckbox
              isSelected={assignedLabelsInt.includes(
                parseInt(parentLabelId, 10),
              )}
              name={labels[parentLabelId].name}
              onSelect={onLabelClick(parentLabelId)}
            />
            {renderChildren(parentLabelId, children)}
          </li>
        </ul>
      ))}

      <div className="p-0 m-0 py-1">
        {showBulkAction && Object.keys(labels).length > 0 && (
          <Button
            isNaked
            onClick={() => actions.activateBulkMode()}
            size="custom"
            className="py-2.8 px-4.2 text-left text-14 block"
          >
            Bulk Label
          </Button>
        )}

        {showCreateNewLabelAction && (
          <Button
            isNaked
            onClick={() => {
              teacherOrganizeNewLabelClickHandler();
            }}
            size="custom"
            className="py-2.8 px-4.2 text-left text-14 block"
          >
            New Label
          </Button>
        )}
      </div>

      {isCreateEditModalVisible && <LabelModal {...createEditModalProps} />}
    </div>
  );
};

export default withRouter(LabelListMenu);
